import script from "./CaskAnnouncementBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskAnnouncementBlock.vue?vue&type=script&setup=true&lang=js"

import "./CaskAnnouncementBlock.vue?vue&type=style&index=0&id=4aeed2a0&lang=scss"

const __exports__ = script;

export default __exports__